import React from 'react';
import cn from 'classnames';

import StripeAccountVerifierModal from 'components/modal/StripeAccountVerifierModal.component';
import { withTranslation } from 'providers/GILT.provider';
import { withSalonRestriction } from 'providers/SalonBasicInfo.provider';
import fromAnyToString from 'utils/converters/fromAnyToString';

import ActivityFeedIcon from 'activity/components/ActivityFeedIcon';
import Footer from 'activity/components/ItemFooter';
import AlertDialog from 'checkout/components/AlertDialog';
import SmsButtonNew from 'scheduler/components/common/SmsButtonNew';
import SmsStoppedTextComponent from 'scheduler/components/Text/SmsStoppedText.component';

import CN from './SmsThreadItem.module.scss';

const fromReceivedTextToStatusMessage = (value) => {
  const uppercased = value.toUpperCase();

  if (uppercased.indexOf('Y') === 0) return 'yes';

  // FIXME: these will not match for YEP, YEAH, YAY, YES because of toUpperCase()
  if (uppercased.indexOf('Yep') === 0) return 'yes';
  if (uppercased.indexOf('Yeah') === 0) return 'yes';
  if (uppercased.indexOf('Yay') === 0) return 'yes';
  if (uppercased.indexOf('Yes') === 0) return 'yes';

  if (uppercased === 'N') return 'no';

  if (value.indexOf('declined') > 0) return 'declined';
  if (value.indexOf('has paid') > 0) return 'd-paid';
  if (value.indexOf('cancelled online') > 0) return 'declined';

  return 'vague';
};

const checkIfMarketingMessage = (options) => {
  const { receivedText, sentText } = options ?? {};

  if (receivedText.indexOf('an upcoming appointment') > 0) return false;
  if (receivedText.indexOf('looking forward to your appointment') > 0) return false;
  if (sentText.indexOf('looking forward to your appointment') > 0) return false;
  if (receivedText.toLowerCase() === 'n') return false;
  // noinspection RedundantIfStatementJS
  if (receivedText.indexOf('cancelled online') > 0) return false;

  return true;
};

class SmsThreadItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      statusMessage: fromReceivedTextToStatusMessage(this.props.receivedText),
      expanded: false,
      showSmS: false,
      smsStoppedModal: false,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.messageSent) setTimeout(() => void this.showSmsPopup(false), 2000);
  }

  showSmsPopup = (showSmS) => {
    if ('STOP' === fromAnyToString(this.props.receivedText).toUpperCase()) {
      this.setState({ smsStoppedModal: true });
    } else {
      this.setState({ showSmS });
    }
  };

  expandedText = () => void this.setState({ expanded: !this.state.expanded }); // FIXME: seems unused, remove if that is true
  markAsRead = () => void this.props.onReadToggle(!this.props.seen);

  render() {
    const { receivedText, sentText, seen, clientName, timestamp, bookingID, clientID: clientIdFromProps } = this.props;
    const {
      isRestrictedToCriticalServices,
      isRestrictionCheckEnabled,
      enableRestrictionCheck,
      disableRestrictionCheck,
    } = this.props;
    const { t } = this.props;
    const { statusMessage, smsStoppedModal, showSmS } = this.state;

    const clientId = [clientIdFromProps];
    const isMarketingMessage = checkIfMarketingMessage({ receivedText, sentText });

    const handleRequestClose = () => void this.setState({ smsStoppedModal: false });

    const handleReply = () => {
      if (isRestrictedToCriticalServices) {
        enableRestrictionCheck();
      } else {
        this.showSmsPopup(true);
      }
    };

    return (
      <div data-bem="SmsThreadItem" className={CN.content}>
        <div className={CN.feedText}>
          <div className={seen ? CN.notSeen : CN.seen} />
          <div className={CN.clientName}>
            <ActivityFeedIcon
              iconName={cn({
                'icon-class': true,
                [`ico-${statusMessage}`]: true,
              })}
            />
            {t('composite.activityFeed.smsThread.replied', { clientName })}
          </div>
          <div className={CN.additionalText}>
            <span className={CN.receivedText}> {receivedText}</span>
            <span className={CN.sentText}>{sentText}</span>
          </div>
        </div>

        <div className={CN.flex}>
          {!isMarketingMessage && (
            <div
              className={CN.viewAppointment}
              role="button"
              tabIndex={bookingID}
              onClick={() => this.props.goToSchedulerAndOpenModal(bookingID, this.props.booking_start_time)}
            >
              {t('composite.activityFeed.smsThread.viewAppointmentButton')}
            </div>
          )}
          <div className={CN.relative}>
            <div className={CN.replyClientName}>
              <span role="button" tabIndex={bookingID} onClick={handleReply}>
                {t('composite.activityFeed.smsThread.replyButton', { clientName })}
              </span>
            </div>
          </div>
          <Footer seen={seen} markAsRead={this.markAsRead} timestamp={timestamp} />
        </div>

        {showSmS && (
          <SmsButtonNew
            bookingID={bookingID}
            clientId={clientId}
            bucketType={this.props.booking_start_time ? 'appointment' : 'one_to_one'}
            clientName={clientName}
            smsComposeModalOpen={showSmS}
            showParentSmsPopup={this.showSmsPopup}
          />
        )}

        {smsStoppedModal && (
          <AlertDialog title="" buttonText="Close" onClick={handleRequestClose} onClose={handleRequestClose}>
            <SmsStoppedTextComponent />
          </AlertDialog>
        )}

        <StripeAccountVerifierModal
          tag="SmsThreadItem__restriction-modal"
          enabled={isRestrictionCheckEnabled}
          onCancel={disableRestrictionCheck}
          onClose={disableRestrictionCheck}
        />
      </div>
    );
  }
}

const SmsThreadItemHoc = withSalonRestriction(withTranslation()(SmsThreadItem));

export default SmsThreadItemHoc;
